function admin(state = {}, action) {
	switch (action.type) {
		case 'GET_ADMIN_PRODUCT_METAS_SUCCESS':
			return {
				...state,
				topDownload: action.payload,
			};
		case 'GET_ADMIN_TOTAL_MODELS_SUCCESS':
			return {
				...state,
				totalModelData: action.payload,
			};
		case 'GET_USER_BILLING_DATAS_SUCCESS':
			return {
				...state,
				userBillings: action.payload,
			};
		default:
			return state;
	}
}

export default admin;



// WEBPACK FOOTER //
// ./routes/admin/routes/dashboard/reducer/index.js